module.exports = __webpack_public_path__ + "img/kip_sunglasses.33fdf03c.png";